module.exports = __webpack_public_path__ + "images/backgrounds/dew/full.8e9ed878facb7d95722f.jpg";